var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegracion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5001 39.1667H23.3334C19.6501 39.1667 16.6667 36.1834 16.6667 32.5C16.6667 28.8167 19.6501 25.8334 23.3334 25.8334H44.1667C46.4668 25.8334 48.3334 27.7 48.3334 30C48.3334 32.3 46.4668 34.1667 44.1667 34.1667H26.6667C25.7501 34.1667 25.0001 33.4167 25.0001 32.5C25.0001 31.5834 25.7501 30.8334 26.6667 30.8334H42.5001V28.3334H26.6667C24.3667 28.3334 22.5001 30.2 22.5001 32.5C22.5001 34.8 24.3667 36.6667 26.6667 36.6667H44.1667C47.8501 36.6667 50.8334 33.6834 50.8334 30C50.8334 26.3167 47.8501 23.3334 44.1667 23.3334H23.3334C18.2667 23.3334 14.1667 27.4334 14.1667 32.5C14.1667 37.5667 18.2667 41.6667 23.3334 41.6667H42.5001V39.1667Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegracion);
export default __webpack_public_path__ + "static/media/integracion.6ccdd261b1149d4d8d27b109388748ed.svg";
export { ForwardRef as ReactComponent };